import { useEffect, useState } from 'react';

export default function RotatingText({ items, interval = 2600 }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % items.length);
    }, interval);

    return () => window.clearInterval(timer);
  }, [items, interval]);

  return (
    <span className="rotating-text" aria-live="polite">
      {items.map((item, itemIndex) => (
        <span
          key={item}
          className={`rotating-text-item ${itemIndex === index ? 'is-active' : ''}`}
        >
          {item}
        </span>
      ))}
    </span>
  );
}
